class HelpStatus extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.startHour = Number(this.dataset.startHour)
    this.endHour = Number(this.dataset.endHour)
    this.startDay = Number(this.dataset.startDay)
    this.endDay = Number(this.dataset.endDay)

    this.updateStatus()
  }

  updateStatus () {
    const now = new Date()

    const ukTime = new Intl.DateTimeFormat('en-GB', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
      timeZone: 'Europe/London',
    }).format(now)

    const [ukHourStr, ukMinuteStr] = ukTime.split(':')
    const ukHour = Number(ukHourStr)
    const ukMinute = Number(ukMinuteStr)

    const weekdayShort = new Intl.DateTimeFormat('en-GB', {
      weekday: 'short',
      timeZone: 'Europe/London',
    }).format(now)

    const daysMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }
    const ukDay = daysMap[weekdayShort]

    let isOnline = false

    // Check day range
    if (this.startDay <= this.endDay) {
      if (ukDay >= this.startDay && ukDay <= this.endDay) isOnline = true
    } else {
      if (ukDay >= this.startDay || ukDay <= this.endDay) isOnline = true
    }

    // Check hour/minute range
    if (isOnline) {
      const startHourH = Math.floor(this.startHour / 100)
      const startHourM = this.startHour % 100
      const endHourH = Math.floor(this.endHour / 100)
      const endHourM = this.endHour % 100

      let inHours = false

      if (
        startHourH < endHourH ||
        (startHourH === endHourH && startHourM < endHourM)
      ) {
        if (
          ukHour > startHourH ||
          (ukHour === startHourH && ukMinute >= startHourM)
        ) {
          if (
            ukHour < endHourH ||
            (ukHour === endHourH && ukMinute < endHourM)
          ) {
            inHours = true
          }
        }
      } else {
        if (
          ukHour > startHourH ||
          (ukHour === startHourH && ukMinute >= startHourM) ||
          ukHour < endHourH ||
          (ukHour === endHourH && ukMinute < endHourM)
        ) {
          inHours = true
        }
      }

      isOnline = inHours
    }

    this.dataset.offline = isOnline ? 'false' : 'true'
  }
}

if (!customElements.get('help-status')) {
  customElements.define('help-status', HelpStatus, { extends: 'sup' })
}
